// redux/reducers/testimonials.js
import {
  GET_TESTIMONIALS_REQUEST,
  GET_TESTIMONIALS_SUCCESS,
  GET_TESTIMONIALS_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  loading: false,
  testimonials: [],
  error: null,
};

export default function testimonialsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TESTIMONIALS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_TESTIMONIALS_SUCCESS:
      return { loading: false, testimonials: action.payload, error: null };
    case GET_TESTIMONIALS_FAILURE:
      return { loading: false, testimonials: [], error: action.payload };
    default:
      return state;
  }
}
